module.exports = __webpack_public_path__ + "static/media/J9.6b5c802b.png";